import React, { useEffect, useState } from "react";
import {
  Grid,
  Card,
  Button,
  CardMedia,
  Typography,
  Tooltip,
  IconButton,
  CardContent,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import imgurl from "./assests/images/imgurl";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import { replace, useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Sidebar from "./components/Sidebar";
import Aloxa from "./Aloxa";
import { setfrontview, setleftview, setrightview, settopview } from "./Reducers/reducer";
import i18n from "./i18n";
import i18next from "i18next";
import { clearImagesInRedux } from "./utils/UtilityFunctions";
import TutorialVideo from "./components/TutorialVideo";

const ImgUpload = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const location = useLocation()
  const [activeTab, setActiveTab] = useState('ai')
  const [gender, setGender] = useState('')

  let { Topview, Backview, Leftview, Rightview, Frontview, Gender } = useSelector(
    (state) => state.user.profile
  );

  useEffect(() => {
    if(location?.state?.goTo === 'aloxa'){
      setActiveTab('ai')
    } else if(location?.state?.goTo === 'taketest'){
      setActiveTab('manual')
    } else if(location.state == "onboardingComplete"){
      localStorage.setItem("valid_user", true);
    }
  }, [location])

  useEffect(() => {
    if(Frontview == '' && Leftview == '' && Rightview == '' && Topview == ''){
      localStorage.setItem('maskconsent', '')
    }
    // handleTestChange()
  }, [])

  useEffect(() => {
    if(Gender == '' && !location?.state?.user_obj?.gender){
      setGender(localStorage.getItem('gender'))
    } else if (location?.state?.user_obj?.gender) {
      setGender(location?.state?.user_obj?.gender)
    } else {
      setGender(Gender)
    }
    console.log("locationn", location);
    
  }, [])

  useEffect(() => {
    if (window.cordova) {
      document.addEventListener("deviceready", function () {
        let permissions = window.cordova.plugins.permissions;
        console.log("cordova.plugins>>>",permissions);
        let requiredPermissions = [permissions.CAMERA, permissions.WRITE_EXTERNAL_STORAGE, permissions.READ_EXTERNAL_STORAGE];
        
        function requestCameraPermission() {
          permissions.requestPermissions(requiredPermissions, function(status) {
              if (status.hasPermission) {
                  console.log("Permissions granted");
                  // Your code to start recording
              } else {
                  console.warn("Permissions denied");
              }
          }, function() {
              console.error("Error requesting permissions");
          });
        }
    
        function checkCameraPermission() {
            let requiredPermissions = [permissions.CAMERA, permissions.WRITE_EXTERNAL_STORAGE, permissions.READ_EXTERNAL_STORAGE];
            permissions.hasPermission(
                requiredPermissions,
                function (status) {
                    if (status.hasPermission) {
                        console.log("Camera permission already granted.");
                    } else {
                        console.log("Requesting camera permission...");
                        requestCameraPermission();
                    }
                },
                function (error) {
                    console.error("Permission check failed:", error);
                }
            );
        }
    
        checkCameraPermission();
      });
    }
  },[])

  const images = gender?.toUpperCase() === 'MALE' ? 
      [
        { label: "Front", src: imgurl.frontImg },
        { label: "Top", src: imgurl.topImg },
        { label: "Left", src: imgurl.leftImg },
        { label: "Right", src: imgurl.rightImg },
        // { label: "Back", src: imgurl.backImg },
      ] 
        : 
      [
        { label: "Front", src: imgurl.femaleFrontImg },
        { label: "Top", src: imgurl.femaleTopImg },
      ]

  function navigateTo(view) {
    if (view == "Front") {
      navigate("/takephotofront", {state:{user_obj: location?.state?.user_obj}});
    } else if (view == "Top") {
      navigate("/takephototop", {state:{user_obj: location?.state?.user_obj}});
    } else if (view == "Left") {
      navigate("/takephotoleft", {state:{user_obj: location?.state?.user_obj}});
    } else if (view == "Right") {
      navigate("/takephotoright", {state:{user_obj: location?.state?.user_obj}});
    } else {
      return;
    }
    //  else {
    //   navigate('/takephotoback')
    // }
  }

  function checkAngle(view) {
    if (view == "Front" && Frontview != "") {
      return true;
    } else if (view == "Top" && Topview != "") {
      return true;
    } else if (view == "Left" && Leftview != "") {
      return true;
    } else if (view == "Right" && Rightview != "") {
      return true;
    } else {
      return false;
    }
  }

  const handleTestChange = (type) => {
    if(Frontview && Rightview && Leftview && Topview){
      swal({
        title: i18next.t('Do you want to discard captured photos?'),
        buttons: {
          cancel: {
            text: i18next.t("No"),
            value: false,
            visible: true,
          },
          confirm: {
            text: i18next.t("Yes"),
            value: true,
            visible: true,
          },
        }
      }).then((val) => {
        // console.log('val::::', val)
        if(val){  
          // if(location?.state?.goTo === 'aloxa' || location?.state?.goTo === 'taketest'){
          //   location.state.goTo = ''
          // }
          clearImagesInRedux(dispatch)
          // if(activeTab === 'ai'){
          //   setActiveTab('manual')
          // } else if(activeTab === 'manual'){
          //   setActiveTab('ai')
          // }
        } else {
          navigate("/preview")
        }
      })
    } 
    // else {
    //   if(type === 'manual'){
    //     // navigate('/taketest')
    //     setActiveTab('manual')
    //   } else if(type === 'ai'){
    //     // navigate('/aloxa')
    //     setActiveTab('ai')
    //   }
    // }
  }

  return (
    <div className="photo-container main-section-container imgUploadSection">
      <Grid
        container
        spacing={0}
        className="d-flex justify-content-start align-items-center"
      >
        {location?.state?.user_obj?.gender && <Grid item xs={1} className="">
          <div className="d-flex justify-content-start align-items-center">
            <span className='backButtonDiv' onClick={() => navigate('/clients')}>
              <ArrowBackOutlinedIcon className='arrowBackBtn'></ArrowBackOutlinedIcon>
            </span>
          </div>
        </Grid>}
        <Grid
          item
          xs={10}
          className="d-flex justify-content-center align-items-center testtypediv"
        >
          <Typography variant="h6" className="title">
            {i18next.t(localStorage.getItem('doctorLogged') ? "Start Hair Analysis" : "Start your Hair Analysis")}
          </Typography>
        </Grid>

        <Grid item xs={1}>
          <Sidebar />
        </Grid>
      </Grid>
      {/* <Button
          className={`commonTextButton ${activeTab === 'manual' ? 'activeaitest' : 'activemanualtest'}`}
          onClick={() => activeTab === 'manual' ? handleTestChange('ai') : handleTestChange('manual')}
        >
          {activeTab === 'manual' ? i18next.t('Switch to Smart Scan') : i18next.t('Switch to Self Scan')}
        </Button> */}
      {
        activeTab === 'manual' ?
        <>
          
          <Typography variant="body2" className="subtitle mt-15px">
            {i18next.t("Tap the images below to take a clear scalp photo.")}
          </Typography>
          <Grid
            container
            spacing={2}
            className={gender?.toUpperCase() == "MALE" ? "grid-container mt-20px imageuploadmain" : "grid-container mt-20px imageuploadmainfemale"}
          >
            {images.map((img, index) => (
              <Grid
                item
                xs={6}
                sm={6}
                lg={6}
                md={6}
                key={index}
                className={gender?.toUpperCase() == "MALE" ? "grid-item uploadAllImage" : "grid-item uploadAllImage no-padding"}
                // {...(index === images.length - 1 ? { xs: 12, sm: 12 } : {})}
              >
                <Card className="photo-card">
                  <CardContent className="pb-16px">
                    <div class="image-container">
                      <CardMedia
                        component="img"
                        image={img.src}
                        alt={img.label}
                        className="card-image"
                        onClick={() => navigateTo(img.label)}
                      />
                      {checkAngle(img.label) && (
                        <div class="overlay" onClick={() => navigateTo(img.label)}>
                          <img src={imgurl.checkicon} alt="Check" />
                        </div>
                      )}
                    </div>
                    <div className="d-flex justify-content-center align-items-start">
                      <Button
                        variant="contained"
                        className="label-button"
                        onClick={() => navigateTo(img.label)}
                      >
                        {img.label}
                      </Button>
                      <Tooltip title="Info" onClick={() => navigateTo(img.label)}>
                        {/* <IconButton className="infoIcon">
                          <InfoIcon />
                        </IconButton> */}
                      </Tooltip>
                    </div>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
          <div className="linkbtnsec">
            {((Topview && Leftview && Rightview && Frontview && gender?.toUpperCase() == "MALE") || (Topview && Frontview && gender?.toUpperCase() == "FEMALE")) && (
              <Button
                variant="contained"
                onClick={() => navigate('/preview', {state: {from: 'selfscan', user_obj: location?.state?.user_obj}})}
                className="commonButton"
              >
                {i18next.t("Proceed")}
              </Button>
            )}
          </div> 
        </> : 
        <>
          <Aloxa/>
        </>
      }
      {/* {
        (Frontview && (!Topview || !Leftview || !Rightview)) || 
        (Topview && (!Frontview || !Leftview || !Rightview)) || 
        (Leftview && (!Topview || !Frontview || !Rightview)) || 
        (Rightview && (!Topview || !Leftview || !Frontview)) ? 
        '' 
          :
        <Button
          className={`commonTextButton pulseBtn ${activeTab === 'manual' ? 'pulseBtn activeaitest' : 'pulseBtn activemanualtest'}`}
          onClick={() => activeTab === 'manual' ? handleTestChange('ai') : handleTestChange('manual')}
        >
          {activeTab === 'manual' ? 'Switch to Smart Scan' : 'Switch to Self Scan'}
        </Button>
      } */}
     
    </div>
  );
};

export default ImgUpload;
